export const featuresList = [
  {
    id: "lender-efficiencies",
    category: "Lender Efficiencies - $325/mo value",
    features: [
      {
        id: "real-time-lender-updates",
        label: "Real-Time Lender Parameter Updates",
        popoverText: "Users can request lenders to update programs in real-time, instantly updating in the system",
        rows: [
          { id: "fundview-real-time", label: "Check" },
          {
            id: "basic-crm-real-time",
            label: "Cancel",
            popoverText: "No built-in lender database; all updates are manual.",
          },
          {
            id: "premium-crm-real-time",
            label: "Cancel",
            popoverText: "May offer lender data but not real-time updates.",
          },
        ],
      },
      {
        id: "lender-heat-map",
        label: "Lender Heat Map & Best-Fit Matching",
        popoverText:
          "Automatically matches managed loans against your lender parameters to quickly identify best-fit lenders and prepare loan packages",
        rows: [
          { id: "fundview-heat-map", label: "Check" },
          {
            id: "basic-crm-heat-map",
            label: "Cancel",
            popoverText: "No lender matching functionality.",
          },
          {
            id: "premium-crm-heat-map",
            label: "Cancel",
            popoverText: "Some platforms offer lender data but lack real-time comparative analysis.",
          },
        ],
      },
      {
        id: "lender-borrower-database",
        label: "Lender & Borrower Database",
        popoverText: "Centralized repository with real-time lender updates.",
        rows: [
          { id: "fundview-database", label: "Check" },
          {
            id: "basic-crm-database",
            label: "Cancel",
            popoverText: "Requires manual setup and lacks CRE-specific intelligence.",
          },
          {
            id: "premium-crm-database",
            label: "Cancel",
            popoverText: "May include lender data but often static or outdated.",
          },
        ],
      },
      {
        id: "advanced-filtering",
        label: "Advanced Filtering & Keyword Search for Lenders",
        popoverText:
          "Sort & filter your lenders by criteria such as loan size, asset type, and terms; quickly search with keywords",
        rows: [
          { id: "fundview-filtering", label: "Check" },
          {
            id: "basic-crm-filtering",
            label: "Cancel",
            popoverText: "No lender filtering; must manually track and search contacts.",
          },
          {
            id: "premium-crm-filtering",
            label: "Cancel",
            popoverText: "Some platforms allow filtering, but not always robust or user-friendly.",
          },
        ],
      },
    ],
  },
  {
    id: "borrower-efficiencies",
    category: "Borrower Efficiencies - $275/mo value",
    features: [
      {
        id: "borrower-portal",
        label: "Borrower Portal & Custom Needs List",
        popoverText: "Automated borrower checklist for document collection and real-time status tracking.",
        rows: [
          { id: "fundview-portal", label: "Check" },
          {
            id: "basic-crm-portal",
            label: "Cancel",
            popoverText: "No borrower portal; manual document requests.",
          },
          {
            id: "premium-crm-portal",
            label: "Cancel",
            popoverText: "May have borrower portals, but often lack dynamic tracking.",
          },
        ],
      },
      {
        id: "loan-summary-generation",
        label: "Loan Summary Generation & Document Attachment",
        popoverText:
          "Quickly generate a loan summary with key details and attach supporting documents for seamless sharing.",
        rows: [
          { id: "fundview-summary", label: "Check" },
          {
            id: "basic-crm-summary",
            label: "Cancel",
            popoverText: "No built-in feature; requires manual document creation and attachment.",
          },
          {
            id: "premium-crm-summary",
            label: "Cancel",
            popoverText: "Some platforms allow document attachments but lack instant summary generation.",
          },
        ],
      },
      {
        id: "automated-loan-process",
        label: "Automated Loan Process Management",
        popoverText: "End-to-end loan lifecycle tracking, including borrower & lender interactions.",
        rows: [
          { id: "fundview-process", label: "Check" },
          {
            id: "basic-crm-process",
            label: "Cancel",
            popoverText: "Requires custom workflows, often inefficient for financing needs.",
          },
          {
            id: "premium-crm-process",
            label: "Cancel",
            popoverText: "Some automation, but often lacks full process visibility.",
          },
        ],
      },
      {
        id: "referral-database",
        label: "Referral Database & Updates",
        popoverText:
          "Built-in referral database with real-time loan status updates, automatically notifying borrowers and referral partners as milestones progress.",
        rows: [
          { id: "fundview-referral", label: "Check" },
          {
            id: "basic-crm-referral",
            label: "Cancel",
            popoverText: "No structured referral tracking; requires manual updates and borrower follow-ups.",
          },
          {
            id: "premium-crm-referral",
            label: "Cancel",
            popoverText: "Some systems may track referrals, but lack automated loan status notifications.",
          },
        ],
      },
    ],
  },
  {
    id: "internal-efficiencies",
    category: "Internal Efficiencies - $400/mo value",
    features: [
      {
        id: "messaging-hub",
        label: "Messaging Hub (Internal & External Communication)",
        popoverText:
          "Centralized messaging hub for full team collaboration; your lenders can be included in discussions, but internal team chats can opt to stay private",
        rows: [
          { id: "fundview-messaging", label: "Check" },
          {
            id: "basic-crm-messaging",
            label: "Cancel",
            popoverText: "No built-in messaging; users must rely on email or third-party tools.",
          },
          {
            id: "premium-crm-messaging",
            label: "Cancel",
            popoverText:
              "Some messaging features, but often lack the ability to separate internal vs. external conversations.",
          },
        ],
      },
      {
        id: "pipeline-deal-tracking",
        label: "Pipeline & Deal Tracking",
        popoverText: "CRE transaction-focused with lender & borrower tracking.",
        rows: [
          { id: "fundview-pipeline", label: "Check" },
          {
            id: "basic-crm-pipeline",
            label: "Cancel",
            popoverText: "Basic sales pipeline, lacks CRE finance-specific stages.",
          },
          {
            id: "premium-crm-pipeline",
            label: "Cancel",
            popoverText:
              "Deal tracking exists but often lacks full financing cycle visibility for borrowers and lenders.",
          },
        ],
      },
      {
        id: "collaboration-workflow",
        label: "Collaboration & Workflow",
        popoverText: "CRE-specific workflows for your team, lenders & clients",
        rows: [
          { id: "fundview-collaboration", label: "Check" },
          {
            id: "basic-crm-collaboration",
            label: "Cancel",
            popoverText: "General collaboration tools, not built for CRE financing.",
          },
          {
            id: "premium-crm-collaboration",
            label: "Cancel",
            popoverText: "Some collaboration tools, but not optimized for multi-party deals.",
          },
        ],
      },
      {
        id: "custom-team-collaboration",
        label: "Custom Team Collaboration & Role-Based Access",
        popoverText:
          "Create teams within the platform, assigning roles to control access to contacts, deals & lender data.",
        rows: [
          { id: "fundview-custom-team", label: "Check" },
          {
            id: "basic-crm-custom-team",
            label: "Cancel",
            popoverText: "Basic collaboration features, but lacks deal-specific access control.",
          },
          {
            id: "premium-crm-custom-team",
            label: "Cancel",
            popoverText: "Some platforms allow role-based access, but often lack lender-specific restrictions.",
          },
        ],
      },
      {
        id: "automated-notifications",
        label: "Automated Notifications & Reminders",
        popoverText: "Auto alerts for outstanding borrower items, new borrower documents, and overdue loan closings.",
        rows: [
          { id: "fundview-notifications", label: "Check" },
          {
            id: "basic-crm-notifications",
            label: "Cancel",
            popoverText: "Generic reminders, no borrower-specific automation.",
          },
          {
            id: "premium-crm-notifications",
            label: "Cancel",
            popoverText: "Some systems offer alerts, but not tailored for CRE finance workflows.",
          },
        ],
      },
    ],
  },
  {
    id: "administrative-cost-efficiencies",
    category: "Administrative & Cost Efficiencies - $200/mo value",
    features: [
      {
        id: "industry-specific-customization",
        label: "Industry-Specific Customization",
        popoverText: "Purpose-built for CRE finance workflows.",
        rows: [
          { id: "fundview-customization", label: "Check" },
          {
            id: "basic-crm-customization",
            label: "Cancel",
            popoverText: "Requires extensive customization.",
          },
          {
            id: "premium-crm-customization",
            label: "Cancel",
            popoverText: "Partially tailored but often rigid and limited.",
          },
        ],
      },
      {
        id: "document-management",
        label: "Document Management",
        popoverText: "Built for loan docs, term sheets, and financial statements with easy tagging.",
        rows: [
          { id: "fundview-docs", label: "Check" },
          {
            id: "basic-crm-docs",
            label: "Cancel",
            popoverText: "Basic document storage, no CRE-specific organization.",
          },
          {
            id: "premium-crm-docs",
            label: "Cancel",
            popoverText: "Some platforms offer doc storage, but often lack automated tagging.",
          },
        ],
      },
      {
        id: "no-data-caps",
        label: "No Data or Entry Caps – No Additional Fees",
        popoverText: "Unlimited data, deals, and entries without additional costs.",
        rows: [
          { id: "fundview-no-caps", label: "Check" },
          {
            id: "basic-crm-no-caps",
            label: "Cancel",
            popoverText: "Many CRMs charge for more data, users, or storage.",
          },
          {
            id: "premium-crm-no-caps",
            label: "Cancel",
            popoverText: "Some CRE software may cap entries and charge for exceeding limits.",
          },
        ],
      },
      {
        id: "mobile-optimization",
        label: "Mobile Optimization",
        popoverText:
          "Fully optimized for mobile, allowing your team, lenders, and borrowers to manage deals from anywhere",
        rows: [
          { id: "fundview-mobile", label: "Check" },
          {
            id: "basic-crm-mobile",
            label: "Cancel",
            popoverText: "Limited mobile functionality; often desktop-first design.",
          },
          {
            id: "premium-crm-mobile",
            label: "Cancel",
            popoverText: "Some platforms support mobile, but often clunky or missing key features.",
          },
        ],
      },
      {
        id: "all-features-included",
        label: "All Features Included – No Add-Ons",
        popoverText: "Every feature available in the suite, no additional costs for 'premium' tools.",
        rows: [
          { id: "fundview-all-features", label: "Check" },
          {
            id: "basic-crm-all-features",
            label: "Cancel",
            popoverText: "Many essential features are gated behind paid add-ons.",
          },
          {
            id: "premium-crm-all-features",
            label: "Cancel",
            popoverText: "Often requires extra modules or higher-tier pricing for full functionality.",
          },
        ],
      },
      {
        id: "ease-of-use",
        label: "Ease of Use for CRE Finance Advisors",
        popoverText: "Intuitive interface built CRE finance intermediaries",
        rows: [
          { id: "fundview-ease", label: "Check" },
          {
            id: "basic-crm-ease",
            label: "Cancel",
            popoverText: "Generic UI that requires adaptation.",
          },
          {
            id: "premium-crm-ease",
            label: "Cancel",
            popoverText: "Often complex, outdated, or difficult to use.",
          },
        ],
      },
      {
        id: "onboarding-support",
        label: "Onboarding & Support",
        popoverText: "CRE finance-expert support & industry training.",
        rows: [
          { id: "fundview-support", label: "Check" },
          {
            id: "basic-crm-support",
            label: "Cancel",
            popoverText: "General support teams unfamiliar with CRE finance.",
          },
          {
            id: "premium-crm-support",
            label: "Cancel",
            popoverText: "Some industry support, but may lack deep advisory expertise.",
          },
        ],
      },
      {
        id: "ready-to-use",
        label: "Ready to Use Immediately – No Customization Required",
        popoverText: "Start implementing features with your borrowers & lenders on Day 1; no setup delays",
        rows: [
          { id: "fundview-ready", label: "Check" },
          {
            id: "basic-crm-ready",
            label: "Cancel",
            popoverText: "Requires heavy customization before use.",
          },
          {
            id: "premium-crm-ready",
            label: "Cancel",
            popoverText: "Often requires weeks or months of setup before full functionality.",
          },
        ],
      },
      {
        id: "fees-commission",
        label: "Fees & Commission",
        popoverText: "No additional fees or commission splits – full access with transparent pricing.",
        rows: [
          { id: "fundview-fees", label: "Check" },
          {
            id: "basic-crm-fees",
            label: "Cancel",
            popoverText: "May charge per user, customization, or API access.",
          },
          {
            id: "premium-crm-fees",
            label: "Cancel",
            popoverText:
              "Some platforms charge per transaction, take a percentage of deals, or require high licensing fees.",
          },
        ],
      },
    ],
  },
];

export const headers = [
  {
    id: "feature",
    label: "Feature",
    tooltip: "Core platform capabilities",
  },
  {
    id: "basicCrm",
    label: "Basic CRM",
    tooltip: "Standard customer relationship management tools",
  },
  {
    id: "premiumCrm",
    label: "Off-the-Shelf CRMs",
    tooltip: "Commercial CRM and CRE-specific software solutions",
  },
  {
    id: "fundview",
    label: "Fundview",
    tooltip: "Complete deal flow platform for CRE finance",
  },
];
